import { PassengerBookingView } from '@mopla/data-models';
import { actionGenerator } from '@mopla/utils';

export enum PassengerBookingActionTypes {
	ReSyncBookings = '[Bookings] ReSync Bookings',
	RemoveBooking = '[Bookings] Remove Booking',
	RemoveBookingResult = '[Bookings] Remove Booking result',
}

/** Triggers collection.reSync() */
export const resyncPassengerBookings = actionGenerator(
	PassengerBookingActionTypes.ReSyncBookings
);

export const removeBooking = actionGenerator<
	PassengerBookingActionTypes.RemoveBooking,
	PassengerBookingView
>(PassengerBookingActionTypes.RemoveBooking);

export const removeBookingResult =
	actionGenerator<PassengerBookingActionTypes.RemoveBookingResult>(
		PassengerBookingActionTypes.RemoveBookingResult
	);

export type TRemoveBookingAction = ReturnType<typeof removeBooking>;
export type TRemoveBookingResultAction = ReturnType<typeof removeBookingResult>;
export type ResyncPassengerBookingsAction = ReturnType<
	typeof resyncPassengerBookings
>;
